module.exports = __webpack_public_path__ + "media/bell.5a4b55a8.wav";